export default __webpack_public_path__ + "static/media/cc.096670ac.svg";